import useSWR from "swr";
import { Tab } from ".";
import { customFetcher, notify } from "../../utils";
import VirtualTable, { CopyIcon } from "../custom/VirtualTable";
import { ChoiceEmployee } from "../../globals/interfaces";
import apiClient from "../../apiClient";
import useLoading from "../../customHooks/useLoading";
import { FormGroup } from "reactstrap";
import { Label } from "reactstrap";
import { Input } from "reactstrap";
import styled from "styled-components";
import ActionIcon from "../custom/ActionIcon";
import { useEffect, useState } from "react";
import { Button } from "reactstrap";
import CopyToClipboard from "react-copy-to-clipboard";

interface NewHirePassword extends ChoiceEmployee {
    guid: string;
    userId: number;
    password: string;
    sentToUser: boolean;
    createdAt: string | Date;
    Send: string;
    Clear: string;
}

export default function NewHirePasswords({
    tabId
}: {
    tabId: Tab;
}) {

    const key = tabId === 'NEW_HIRE_PASSWORDS' ? `/new-hire-passwords` : null;
    const {
        data,
        mutate
    } = useSWR(key, customFetcher<NewHirePassword>);
    const { setLoading } = useLoading();
    const [s_email, set_s_email] = useState('');
    const [searchUser, setSearchUser] = useState<NewHirePassword>();

    const sendPassToUser = async (item: NewHirePassword) => {
        try {
            setLoading(true);
            const { guid, s_phone_num, s_email, s_first_name, s_last_name, password } = item;
            const res = await apiClient.post(`/send-pass-to-user`, {
                guid,
                s_phone_num,
                name: `${s_first_name} ${s_last_name}`,
                password,
                s_email
            });
            notify('Email/Password sent to user');
        } catch (err) {
            alert(err);
        } finally {
            setLoading(false);
        }
    }

    const remove = (guid) => {
        const updatedData = data.filter(item => item.guid !== guid);
        mutate(updatedData, false);
    }

    const resetExistingPassword = async () => {
        if (!s_email || !s_email.length) return;
        try {
            setSearchUser(null);
            const res = await apiClient.get(`/reset-existing-password/${s_email}`);
            setSearchUser(res.data);
        } catch (err) {
            notify('User not found', 'error');
        }
    }

    useEffect(() => {
        setSearchUser(undefined);
    }, [s_email]);

    return (
        <div>
            <FlexContainer>
                <Label>Search by email: </Label>
                <Input value={s_email} onChange={e => set_s_email(e.target.value)} />
                <ActionIcon
                    type={'search'}
                    onClick={resetExistingPassword}
                    disabled={!s_email || !s_email.length}
                />
                {
                    searchUser && (
                        <FlexContainer>
                            <h6>User found: {searchUser.s_first_name} {searchUser.s_last_name} ({searchUser.s_home_station})</h6>
                            <CopyToClipboard text={searchUser.password}>
                                <CopyIcon
                                    className="fa-duotone fa-copy text-success"
                                    onClick={() => notify('Copied')}
                                />
                            </CopyToClipboard>
                            <Button onClick={() => sendPassToUser(searchUser)}>Reset Password</Button>
                        </FlexContainer>
                    )
                }
            </FlexContainer>
            <VirtualTable<NewHirePassword>
                data={data}
                mapping={[{
                    name: 'Unit',
                    value: 's_home_station',
                    customWidth: 75
                }, {
                    name: 'First name',
                    value: 's_first_name'
                }, {
                    name: 'Last name',
                    value: 's_last_name'
                }, {
                    name: 'Email',
                    value: 's_email'
                }, {
                    name: 'Password',
                    value: 'password',
                    password: true,
                    customWidth: 75
                }, {
                    name: 'Created date',
                    value: 'createdAt',
                    datetime: true,
                    utc: true
                }, {
                    name: 'Send to Employee',
                    value: 'Send',
                    button: true,
                    function: item => sendPassToUser(item)
                }, {
                    name: '',
                    value: 'fas fa-trash',
                    icon: true,
                    function: item => remove(item.guid)
                }]}
            />
        </div>
    );
}

const FlexContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 15px 0px;

    input  {
        width: 25%;
    }
`;